import { render, staticRenderFns } from "./ChatOrderProfileCard.vue?vue&type=template&id=34537910&scoped=true&"
import script from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileCard.vue?vue&type=style&index=0&id=34537910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34537910",
  null
  
)

export default component.exports